<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M6.75 4.125V2.625C6.75 2.211 7.086 1.875 7.5 1.875H8.25V0H6.75C5.50725 0 4.5 1.00725 4.5 2.25V4.125H3V6H4.5V12H6.75V6H8.25L9 4.125H6.75Z" fill="white"/>
</svg>